<template>
  <div
    class="overflow-auto w-100 vh-100 d-flex flex-column"
    id="window"
    :class="containerClass"
    v-auto-animate="{ duration: 200 }"
  >
    <NavBar :theme="globalStore.theme" />

    <RouterView />
    <div
      id="innerModals"
      class="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted } from "vue";
import NavBar from "./components/navbar//Navbar.vue";
import { useGlobalStore } from "./stores/GlobalStore";

const globalStore = useGlobalStore();

onMounted(() => {
  globalStore.getState();
  globalStore.updateIsMobile();
  window.addEventListener("resize", globalStore.updateIsMobile);
  // console.log(document.getElementById("window")?.innerHTML);
  // globalStore.theme
});
onUnmounted(() => {
  window.removeEventListener("resize", globalStore.updateIsMobile);
});

const containerClass = computed(() => {
  const isDarkTheme = globalStore.theme === "dark"; // Determine the theme

  const gradientBg = globalStore.bgThemeClass;

  const textColor = isDarkTheme ? "text-light" : "text-black";

  return `${gradientBg} ${textColor}`;
});

// const containerClass = computed(() => {
//   return `bg-${globalStore.theme} text-${globalStore.theme === "dark" ? "light" : "black"}`;
// });
</script>
